import config from '@/lib/config';
import TaggedActivity from '../templates/metrics/TaggedActivity';

const Administrative = new TaggedActivity({
  name: 'Administrative',
  tag: config.INSIGHTS.TAGS.ADMINISTRATIVE,
});

export default Administrative;
